import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { toast } from "sonner";

export default function AdminPages() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/pages").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    await api.post("/admin/pages", edit);
    toast.success("Saved"); setEdit(null); load();
  };

  return (
    <div data-testid="admin-pages">
      <div className="border-b border-border pb-4 mb-6">
        <h1 className="font-display text-4xl tracking-tight">Site content</h1>
        <p className="text-sm text-muted-foreground italic mt-1">Edit your About, Contact, Terms, Privacy, Refund &amp; Disclaimer pages.</p>
      </div>

      {!edit ? (
        <div className="border border-border rounded-sm bg-card divide-y divide-border">
          {items.map((p) => (
            <div key={p.slug} className="flex items-center justify-between px-4 py-3" data-testid={`page-row-${p.slug}`}>
              <div>
                <div className="font-display text-lg">{p.title}</div>
                <div className="text-xs text-muted-foreground font-mono">/{p.slug} {p.is_default && <span className="italic ml-2">(using default)</span>}</div>
              </div>
              <Button variant="ghost" size="sm" onClick={() => setEdit({ ...p, published: p.published !== false })} data-testid={`edit-page-${p.slug}`}>Edit</Button>
            </div>
          ))}
        </div>
      ) : (
        <div className="border border-border rounded-sm bg-card p-6 space-y-4 max-w-3xl">
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Slug</Label><Input value={edit.slug} onChange={(e) => setEdit({ ...edit, slug: e.target.value })} className="rounded-sm mt-1.5 font-mono" data-testid="pg-slug" /></div>
            <div><Label>Title</Label><Input value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} className="rounded-sm mt-1.5" data-testid="pg-title" /></div>
          </div>
          <div><Label>Content (markdown-lite: **bold** supported)</Label>
            <Textarea rows={18} value={edit.content} onChange={(e) => setEdit({ ...edit, content: e.target.value })} className="rounded-sm mt-1.5 font-mono text-sm" data-testid="pg-content" />
          </div>
          <div className="flex items-center gap-2">
            <Switch checked={edit.published} onCheckedChange={(v) => setEdit({ ...edit, published: v })} id="pg-pub" />
            <Label htmlFor="pg-pub">Published</Label>
          </div>
          <div className="flex gap-2">
            <Button variant="ghost" onClick={() => setEdit(null)} className="rounded-sm">Cancel</Button>
            <Button onClick={save} className="rounded-sm" data-testid="pg-save">Save</Button>
          </div>
        </div>
      )}
    </div>
  );
}
